var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonacoCardBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 51 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76385 0.000594885L45.4236 0.000593107C46.8175 0.000593046 48.0762 0.554403 48.9468 1.43712C49.7182 2.2199 50.1874 3.26083 50.1874 4.40169L50.1874 67.6031C50.1874 68.7398 49.7183 69.7766 48.9513 70.5594C48.0762 71.4462 46.822 72 45.4236 72L4.76386 72C3.30222 72 1.99397 71.3921 1.1233 70.4386C0.419547 69.6683 -1.45055e-07 68.6815 -1.92194e-07 67.6031L-2.95482e-06 4.4017C-3.00195e-06 3.32329 0.419546 2.33229 1.11879 1.56616C1.98945 0.608505 3.2977 0.000594949 4.76385 0.000594885Z",
    fill: "url(#paint0_linear_3243_17623)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00097637 67.6031C0.000976417 68.6815 0.420523 69.6683 1.12427 70.4386C1.99494 71.3921 3.30319 72 4.76483 72L13.5256 72L25.0924 36.0003L0.000975872 56.1945L0.00097637 67.6031Z",
    fill: "url(#paint1_linear_3243_17623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4841 72L45.4254 72C46.8239 72 48.078 71.4462 48.9532 70.5594C49.7201 69.7766 50.1892 68.7398 50.1892 67.6031L50.1892 56.3193L25.0933 36.0003L36.4841 72Z",
    fill: "url(#paint2_linear_3243_17623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1892 4.40137C50.1892 3.26051 49.7201 2.21958 48.9486 1.43679C48.078 0.55408 46.8193 0.000273709 45.4254 0.000273769L36.6601 0.000274153L25.0933 36L50.1892 15.8059L50.1892 4.40137Z",
    fill: "url(#paint3_linear_3243_17623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7066 0.000274059L4.76532 0.00027445C3.29917 0.000274514 1.99092 0.608185 1.12025 1.56585C0.421013 2.33197 0.00146342 3.32297 0.00146346 4.40137L0.00146396 15.6893L25.0929 36L13.7066 0.000274059Z",
    fill: "url(#paint4_linear_3243_17623)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4919 4.08594L7.69679 4.08594C6.21685 4.08594 5.01709 5.19326 5.01709 6.5592L5.01709 65.4428C5.01709 66.8087 6.21685 67.9161 7.69679 67.9161L42.4919 67.9161C43.9718 67.9161 45.1715 66.8087 45.1715 65.4428L45.1715 6.5592C45.1715 5.19325 43.9718 4.08594 42.4919 4.08594Z",
    stroke: "url(#paint5_linear_3243_17623)",
    strokeWidth: 1.80449,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3243_17623",
    x1: 25.096,
    y1: 72,
    x2: 25.096,
    y2: 0.000593996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D3BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B2FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3243_17623",
    x1: 25.0924,
    y1: 54.0002,
    x2: -3.9283,
    y2: 54.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B0549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3243_17623",
    x1: 50.1892,
    y1: 367.621,
    x2: 21.164,
    y2: 367.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B0549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3243_17623",
    x1: 50.1892,
    y1: 18.0001,
    x2: 21.164,
    y2: 18.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B0549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3243_17623",
    x1: -1287.79,
    y1: 18.0002,
    x2: -1287.34,
    y2: 18.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B0549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3243_17623",
    x1: 25.0921,
    y1: 3.25735,
    x2: 25.0921,
    y2: 68.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB663"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonacoCardBack);
export default __webpack_public_path__ + "static/media/monaco-card-back.457f7b8089e3811529ab5722a1212474.svg";
export { ForwardRef as ReactComponent };